import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AdminProfileModel } from '../pages/model/admin-profile/admin-profile.model';
import { Subject } from 'rxjs';
import { forkJoin, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ApiService {


  private baseUrl = `${environment.apiUrl}/admin`;

  constructor(private http: HttpClient) {}

  getHeaders() {
    const token = localStorage.getItem("authToken");
    return {
      headers: new HttpHeaders({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      })
    };
  }

  // ----------------- CATEGORY -----------------

  getCategories(): Observable<any> {
    return this.http.get(`${this.baseUrl}/category`, this.getHeaders());
  }

  addCategory(body: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/category`, body, this.getHeaders());
  }

  editCategory(id: number, body: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/category/${id}`, body, this.getHeaders());
  }

  deleteCategory(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/category/${id}`, this.getHeaders());
  }

  // ----------------- SUBCATEGORY -----------------

  // GET all subcategories for a category
  getSubCategories(categoryId: number): Observable<any> {
    return this.http.get(
      `${this.baseUrl}/category/${categoryId}/subcategory`,
      this.getHeaders()
    );
  }

  // CREATE new subcategory
  addSubCategory(body: any): Observable<any> {
    return this.http.post(
      `${this.baseUrl}/category/${body.categoryId}/subcategory`,
      body,
      this.getHeaders()
    );
  }

  // UPDATE subcategory
  editSubCategory(id: number, body: any): Observable<any> {
    return this.http.put(
      `${this.baseUrl}/subcategory/${id}`,
      body,
      this.getHeaders()
    );
  }

  // DELETE subcategory
  deleteSubCategory(id: number): Observable<any> {
    return this.http.delete(
      `${this.baseUrl}/subcategory/${id}`,
      this.getHeaders()
    );
  }

  // TOGGLE subcategory active/inactive status
toggleSubCategoryStatus(id: number): Observable<any> {
  return this.http.patch(
    `${this.baseUrl}/subcategory/updateStatus/${id}`,
    {},
    this.getHeaders()
  );
}

uploadCategoryImage(file: File): Observable<any> {
  const formData = new FormData();
  formData.append("catImage", file);

  return this.http.post(
    `${this.baseUrl}/upload/category-image`,
    formData,
    {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      })
    }
  );
}

uploadSubCategoryImage(file: File): Observable<any> {
  const formData = new FormData();
  formData.append("subImage", file);

  return this.http.post(
    `${this.baseUrl}/upload/subcategory-image`,
    formData,
    {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      })
    }
  );
}

adminLogin(body: any) {
  return this.http.post(`${this.baseUrl}/login`, body);
}

  // ----------------- BLOGS -----------------

  // GET all blogs
  getBlogs(): Observable<any> {
    return this.http.get(`${this.baseUrl}/blogs`, this.getHeaders());
  }

  // GET blog by ID
  getBlogById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/blogs/${id}`, this.getHeaders());
  }

  // CREATE blog
  createBlog(body: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/blogs`, body, this.getHeaders());
  }

  // UPDATE blog
  updateBlog(id: number, body: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/blogs/${id}`, body, this.getHeaders());
  }

  // DELETE blog
  deleteBlog(id: number): Observable<any> {
    return this.http.delete(`${this.baseUrl}/blogs/${id}`, this.getHeaders());
  }

  // UPLOAD blog image
  uploadBlogImage(file: File): Observable<any> {
    const formData = new FormData();
    formData.append("image", file);

    return this.http.post(
      `${this.baseUrl}/upload/blog-image`,
      formData,
      {
        headers: new HttpHeaders({
          Authorization: `Bearer ${localStorage.getItem("authToken")}`
        })
      }
    );
  }

  // ----------------- USERS -----------------

getUsers(): Observable<any> {
  return this.http.get(`${this.baseUrl}/users`, this.getHeaders());
}

getUserById(id: number): Observable<any> {
  return this.http.get(`${this.baseUrl}/users/${id}`, this.getHeaders());
}

updateUserStatus(id: number, body: any): Observable<any> {
  return this.http.patch(
    `${this.baseUrl}/users/${id}/status`,
    body,
    this.getHeaders()
  );
}

updateUserPhone(id: number, body: any): Observable<any> {
  return this.http.patch(
    `${this.baseUrl}/users/${id}/phone`,
    body,
    this.getHeaders()
  );
}


  // ----------------- SERVICES -----------------

// GET all services
getServices(): Observable<any> {
  return this.http.get(
    `${this.baseUrl}/services`,
    this.getHeaders()
  );
}

// GET service by ID
getServiceById(id: number): Observable<any> {
  return this.http.get(
    `${this.baseUrl}/services/${id}`,
    this.getHeaders()
  );
}

// CREATE a service
addService(body: any): Observable<any> {
  return this.http.post(
    `${this.baseUrl}/services`,
    body,
    this.getHeaders()
  );
}

// UPDATE a service
editService(id: number, body: any): Observable<any> {
  return this.http.put(
    `${this.baseUrl}/services/${id}`,
    body,
    this.getHeaders()
  );
}

// DELETE a service
deleteService(id: number): Observable<any> {
  return this.http.delete(
    `${this.baseUrl}/services/${id}`,
    this.getHeaders()
  );
}

// TOGGLE service active/inactive
toggleServiceStatus(id: number): Observable<any> {
  return this.http.patch(
    `${this.baseUrl}/services/updateStatus/${id}`,
    {},
    this.getHeaders()
  );
}

// UPLOAD service image
uploadServiceImage(file: File): Observable<any> {
  const formData = new FormData();
  formData.append("serviceImage", file);

  return this.http.post(
    `${this.baseUrl}/upload/service-image`,
    formData,
    {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      })
    }
  );
}

getAllSubCategories(): Observable<any> {
  return this.http.get(`${this.baseUrl}/subcategories`, this.getHeaders())
    .pipe(
      map((res: any) => ({
        success: res.success,
        data: res.subcategories ?? res.data ?? []
      }))
    );
}

getServicesBySubCategory(subcatId: number): Observable<any> {
  return new Observable(observer => {
    this.getServices().subscribe({
      next: (res: any) => {
        const filtered = res.data.filter(s => s.subcat === subcatId);
        observer.next({ success: true, data: filtered });
        observer.complete();
      },
      error: err => observer.error(err)
    });
  });
}


// ----------------- ARTISTS -----------------

// GET all artists
getArtists(): Observable<any> {
  return this.http.get(`${this.baseUrl}/artists`, this.getHeaders());
}

getArtistById(id: number): Observable<any> {
  return this.http.get(`${this.baseUrl}/artist/${id}`, this.getHeaders());
}

toggleArtistStatus(id: number): Observable<any> {
  return this.http.patch(
    `${this.baseUrl}/artist/${id}/toggle-suspend`,
    {},
    this.getHeaders()
  );
}
toggleVerifyArtist(id: number): Observable<any> {
  return this.http.patch(
    `${this.baseUrl}/artist/${id}/toggle-verify`,
    {},
    this.getHeaders()
  );
}

updateArtist(id: number, body: any): Observable<any> {
  return this.http.put(
    `${this.baseUrl}/artist/${id}`,
    body,
    this.getHeaders()
  );
}

// ----------------- ADMIN PROFILE -----------------

// ----------------- ADMIN PROFILE -----------------

getAdminProfile(): Observable<any> {
  return this.http.get(`${this.baseUrl}/profile`, this.getHeaders());
}

updateAdminProfile(body: any): Observable<any> {
  return this.http.put(`${this.baseUrl}/update-profile`, body, this.getHeaders());
}

changeAdminPassword(oldPassword: string, newPassword: string, confirmPassword: string) {
  return this.http.put(
    `${this.baseUrl}/change-password`,
    { oldPassword, newPassword, confirmPassword },
    this.getHeaders()
  );
}

// ADD THIS ↓↓↓
uploadAdminImage(formData: FormData): Observable<any> {
  return this.http.post(
    `${this.baseUrl}/upload/admin-image`,
    formData,
    {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      })
    }
  );
}


// notification

getAdminNotifications() {
  return this.http.get(`${this.baseUrl}/notifications`, this.getHeaders());
}

updatePaymentSettings(body: any): Observable<any> {
  return this.http.put(`${this.baseUrl}/update-payment-settings`, body, this.getHeaders());
}


// --------------------------------------------------------------------------------------------

// getMockProfile(): Observable<AdminProfileModel> {
//     return this.http.get<AdminProfileModel>('/assets/data/profile.json');
// }

// getMockNotifications() {
//   return this.http.get<any[]>('/assets/data/notifications.json');
// }

// // returns array or null
// getLocalNotifications() {
//   const s = localStorage.getItem('adminNotifications');
//   return s ? JSON.parse(s) : null;
// }

// saveLocalNotifications(list: any[]) {
//   localStorage.setItem('adminNotifications', JSON.stringify(list));
// }

profileUpdated$ = new Subject<boolean>();

// saveLocalProfile(profile: any) {
//   localStorage.setItem('adminProfile', JSON.stringify(profile));
//   this.profileUpdated$.next();   // 🔥 Notify header to reload profile
// }

// getLocalProfile() {
//   const saved = localStorage.getItem('adminProfile');
//   if (saved) return JSON.parse(saved);
//   return null;
// }


// ----------------- SPONSORS -----------------

// GET all sponsors
getSponsors(): Observable<any> {
  return this.http.get(`${this.baseUrl}/sponsor`, this.getHeaders());
}

// GET sponsor by ID
getSponsorById(id: number): Observable<any> {
  return this.http.get(`${this.baseUrl}/sponsor/${id}`, this.getHeaders());
}

// CREATE sponsor
createSponsor(body: any): Observable<any> {
  return this.http.post(`${this.baseUrl}/sponsor`, body, this.getHeaders());
}

// UPDATE sponsor
updateSponsor(id: number, body: any): Observable<any> {
  return this.http.put(`${this.baseUrl}/sponsor/${id}`, body, this.getHeaders());
}

// DELETE sponsor
deleteSponsor(id: number): Observable<any> {
  return this.http.delete(`${this.baseUrl}/sponsor/${id}`, this.getHeaders());
}

// TOGGLE Active / Inactive
toggleSponsorStatus(id: number): Observable<any> {
  return this.http.patch(`${this.baseUrl}/sponsor/updateStatus/${id}`, {}, this.getHeaders());
}

// UPLOAD sponsor image
uploadSponsorImage(file: File): Observable<any> {
  const formData = new FormData();
  formData.append("image", file);

  return this.http.post(
    `${this.baseUrl}/upload/sponsor-image`,
    formData,
    {
      headers: new HttpHeaders({
        Authorization: `Bearer ${localStorage.getItem("authToken")}`
      })
    }
  );
}


// ----------------- SPONSORS -----------------

// private LS_SPONSORS_KEY = "admin_sponsors_mock";

// private getLocalSponsors() {
//   const data = localStorage.getItem(this.LS_SPONSORS_KEY);
//   return data ? JSON.parse(data) : [];
// }

// private saveLocalSponsors(list: any[]) {
//   localStorage.setItem(this.LS_SPONSORS_KEY, JSON.stringify(list));
// }

// // GET all sponsors
// getSponsors(): Observable<any> {
//   return this.http.get(`${this.baseUrl}/sponsors`, this.getHeaders()).pipe(
//     catchError(() => {
//       console.warn("⚠️ API failed → loading sponsors from LocalStorage");

//       return of({
//         success: true,
//         data: this.getLocalSponsors()
//       });
//     })
//   );
// }

// // GET sponsor by ID
// getSponsorById(id: number): Observable<any> {
//   return this.http.get(`${this.baseUrl}/sponsors/${id}`, this.getHeaders()).pipe(
//     catchError(() => {
//       const list = this.getLocalSponsors();
//       const item = list.find((x: any) => x.id == id);

//       return of({ success: true, data: item });
//     })
//   );
// }

// // CREATE sponsor
// createSponsor(body: any): Observable<any> {
//   return this.http.post(`${this.baseUrl}/sponsors`, body, this.getHeaders()).pipe(
//     catchError(() => {
//       console.warn("⚠️ API failed → saving sponsor to LocalStorage");

//       const list = this.getLocalSponsors();
//       body.id = Date.now();

//       list.push(body);
//       this.saveLocalSponsors(list);

//       return of({ success: true, data: body });
//     })
//   );
// }

// // UPDATE sponsor
// updateSponsor(id: number, body: any): Observable<any> {
//   return this.http.put(`${this.baseUrl}/sponsors/${id}`, body, this.getHeaders()).pipe(
//     catchError(() => {
//       const list = this.getLocalSponsors();
//       const index = list.findIndex((x: any) => x.id == id);

//       if (index !== -1) {
//         list[index] = { ...list[index], ...body };
//         this.saveLocalSponsors(list);
//       }

//       return of({ success: true });
//     })
//   );
// }

// // DELETE sponsor
// deleteSponsor(id: number): Observable<any> {
//   return this.http.delete(`${this.baseUrl}/sponsors/${id}`, this.getHeaders()).pipe(
//     catchError(() => {
//       const list = this.getLocalSponsors();
//       const filtered = list.filter((x: any) => x.id != id);

//       this.saveLocalSponsors(filtered);

//       return of({ success: true });
//     })
//   );
// }

// // TOGGLE Active / Inactive
// toggleSponsorStatus(id: number): Observable<any> {
//   return this.http.patch(`${this.baseUrl}/sponsors/updateStatus/${id}`, {}, this.getHeaders()).pipe(
//     catchError(() => {
//       const list = this.getLocalSponsors();
//       const index = list.findIndex((x: any) => x.id == id);

//       if (index !== -1) {
//         list[index].status = list[index].status === "active" ? "inactive" : "active";
//         this.saveLocalSponsors(list);
//       }

//       return of({ success: true });
//     })
//   );
// }

// // UPLOAD sponsor image
// uploadSponsorImage(file: File): Observable<any> {
//   const formData = new FormData();
//   formData.append("image", file);

//   return this.http.post(`${this.baseUrl}/upload/sponsor-image`, formData, {
//     headers: new HttpHeaders({
//       Authorization: `Bearer ${localStorage.getItem("authToken")}`,
//     }),
//   }).pipe(
//     catchError(() => {
//       console.warn("⚠️ Using LocalStorage mock image upload");

//       return of({
//         success: true,
//         imageUrl: "https://via.placeholder.com/300x200?text=Mock+Image"
//       });
//     })
//   );
// }


// ----------------- BOOKINGS -----------------

// getBookings(): Observable<any> {
//   return this.http.get(`${this.baseUrl}/bookings`, this.getHeaders());
// }
getBookings(): Observable<any> {
  return this.http.get(
    `${this.baseUrl}/list/booking`,
    this.getHeaders()
  );
}




deleteBooking(id: number): Observable<any> {
  return this.http.delete(`${this.baseUrl}/bookings/${id}`, this.getHeaders());
}

getBookingById(id: number): Observable<any> {
  return this.http.get(`${this.baseUrl}/bookings/${id}`, this.getHeaders());
}

cancelBooking(id: number) {
  return this.http.patch(
    `${this.baseUrl}/bookings/${id}/cancel`,
    {},
    this.getHeaders()
  );
}

// RESCHEDULE booking
rescheduleBooking(id: number, body: any) {
  return this.http.patch(
    `${this.baseUrl}/bookings/${id}/reschedule`,
    body,
    this.getHeaders()
  );
}

// getBookingsByArtist(artistId: number): Observable<any> {
//   return this.http.get(`${this.baseUrl}/bookings/artist/${artistId}`);
// }


getBookingsByArtist(artistId: number): Observable<any> {
  return this.http.get(
    `${environment.apiUrl}/${artistId}/bookings`,
    this.getHeaders()
  );
}

getUserBookings(userId: number): Observable<any> {
  return this.http.get(
    `${environment.apiUrl}/booking/${userId}`,
    this.getHeaders()
  );
}


// ----------------- CUSTOM PAGES / PRIVACY POLICY -----------------

// CREATE privacy policy or custom page
// createCustomPage(body: {
//   title: string;
//   page_name: string;
//   description: string; // HTML
// }): Observable<any> {
//   return this.http.post(
//     `${environment.apiUrl}/privacy-policy`,
//     body,
//     this.getHeaders()
//   );
// }

// // UPDATE privacy policy or custom page
// updateCustomPage(id: number, body: {
//   title?: string;
//   page_name?: string;
//   description?: string;
// }): Observable<any> {
//   return this.http.put(
//     `${environment.apiUrl}/privacy-policy/${id}`,
//     body,
//     this.getHeaders()
//   );
// }

// // GET all custom pages
// getCustomPages(): Observable<any> {
//   return this.http.get(
//     `${environment.apiUrl}/privacy-policy`,
//     this.getHeaders()
//   );
// }

// // GET page by page_name (for website/app)
// getCustomPageByName(pageName: string): Observable<any> {
//   return this.http.get(
//     `${environment.apiUrl}/privacy-policy/${pageName}`,
//     this.getHeaders()
//   );
// }


// ----------------- CUSTOM PAGES -----------------

// getCustomPages(): Observable<any[]> {
//   return this.http.get<any[]>(
//     `${environment.apiUrl}/privacy-policy`,
//     this.getHeaders()
//   );
// }

getCustomPages(): Observable<any> {
  return this.http.get(
    `${environment.apiUrl}/privacy-policy`,
    this.getHeaders()
  );
}

createCustomPage(body: {
  title: string;
  page_name: string;
  description: string;
}) {
  return this.http.post(
    `${environment.apiUrl}/privacy-policy`,
    body,
    this.getHeaders()
  );
}

updateCustomPage(id: number, body: any) {
  return this.http.put(
    `${environment.apiUrl}/privacy-policy/${id}`,
    body,
    this.getHeaders()
  );
}

// getCustomPageById(id: number) {
//   return this.http.get(
//     `${environment.apiUrl}/privacy-policy/${id}`,
//     this.getHeaders()
//   );
// }

// Replace the getCustomPageById method with this:
getCustomPageById(id: number): Observable<any> {
  // First get all pages, then filter by ID
  return this.getCustomPages().pipe(
    map((res: any) => {
      const pages = res.data || res || [];
      const page = pages.find((p: any) => p.id === id);

      if (!page) {
        throw new Error('Page not found');
      }

      return { success: true, data: page };
    })
  );
}

getPageants(): Observable<any> {
  return this.http.get(`${environment.apiUrl}/pageants`, this.getHeaders());
}

getCategoriesByPageant(pageantId: any): Observable<any> {
  return this.http.get(`${environment.apiUrl}/pageants/${pageantId}/category`, this.getHeaders());
}

createContestant(body: any): Observable<any> {
  return this.http.post(`${environment.apiUrl}/contestants`, body, this.getHeaders());
}

getContestants(): Observable<any> {
  return this.http.get(`${environment.apiUrl}/contestants`, this.getHeaders());
}

deleteContestant(id: any): Observable<any> {
  return this.http.delete(`${environment.apiUrl}/contestants/${id}`, this.getHeaders());
}


}
